
import confs from '../configurations';

const { URL_GED } = confs;

export const welcomeLogo = URL_GED+'/Societe/main-logo.jpg';
export const logo = URL_GED+'/Societe/logo.jpg';

